import * as React from "react";
import { CheckboxWithLabel, CheckboxWithLabelProps } from "formik-mui";
import { Field, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { FormHelperText } from "@mui/material";
import Stack from "@mui/material/Stack";

interface Props extends Omit<CheckboxWithLabelProps, "field" | "form" | "meta"> {
  name: string;
  helperText?: string;
}

const CheckboxField: React.FC<Props> = ({ name, helperText, required, ...props }) => {
  const { t } = useTranslation();
  const { errors, touched } = useFormikContext<Record<string, boolean>>();
  const helperId = `${name}-helper-text`;

  const validate = React.useCallback(
    (value: string | undefined) => {
      if (required && !value) {
        return t("common.validation.required");
      }
      return undefined;
    },
    [required, t]
  );

  return (
    <Stack flexGrow={0}>
      <Field
        name={name}
        type="checkbox"
        component={CheckboxWithLabel}
        validate={validate}
        inputProps={{ "aria-describedby": helperId }}
        {...props}
      />
      <FormHelperText id={helperId} margin="dense" required={required} error={touched[name] && !!errors[name]}>
        {(touched[name] && errors[name]) || helperText}
      </FormHelperText>
    </Stack>
  );
};

export { CheckboxField };
